<template>
    <div class="inner-title global-margin global-inner flex inner-title-mtb relative z-10">
        <div v-for="(item, index) in list" :key="index" @click="clickFunc(item, index)"
            :class="[active === index ? 'active' : '', 'item flex-1 flex-nowrap items-center justify-center flex']">{{
                item.title || item.category_name
            }}</div>
    </div>
</template>

<script>
export default {
    name: "innerTitle",
    // components: { Sidentify },
    props: {
        list: {
            type: Array,
            default: []
        },
        active: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        clickFunc(item, index) {
            this.$emit('action', item, index)
        }
    },
};
</script>

<style lang="less" scoped>
.inner-title {
    font-size: 20px;
    // margin: ;

    .item {
        color: @text-defauft-color;
        // width: 100%;
        text-align: center;
        padding: 16px 0;
    }

    .active {
        background: @primaryColor;
        color: #fff;
    }

    @media screen and (max-width: 767px) {
        .item {
            padding: 16px 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/InnerTitle.vue